import * as Sentry from "@sentry/react";

// Only initialize Sentry when VITE_DEBUG is "false" (production mode)
if (import.meta.env.VITE_DEBUG === "false") {
  Sentry.init({
    dsn: "https://07c7a1914a61d9f50e937a867d1e3d83@o618437.ingest.us.sentry.io/4509798222266369",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // NOTE: This will disable built-in masking. Only use this if your site has no sensitive data, or if you've already set up other options for masking or blocking relevant data, such as 'ignore', 'block', 'mask' and 'maskFn'.
        maskAllText: false,
        blockAllMedia: false,
      })
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    // Logs
    enableLogs: true,
    // Environment
    environment: import.meta.env.VITE_DEBUG === "false" ? "production" : "development",
    // Release version (you can set this to your app version)
    release: import.meta.env.VITE_APP_VERSION || "1.0.0",
  });

  console.log('[Sentry] Initialized in production mode');
} else {
  console.log('[Sentry] Skipped initialization in development mode');
}

export { Sentry }; 